<div class="container-shroud" [class.open]="open()">
    <ng-container #content></ng-container>
</div>
